import * as actions from './actions';
import sendGoogleAnalyticsEvent from '../../utils/tracking/googleAnalytics';
import * as googleAnalyticsEvents from '../../utils/tracking/googleAnalytics';

const eventMappings = {};
eventMappings[actions.VIDEO_COMPLETED] = [trackCompleteAction];

export default function trackVideo(type, state) {
    const eventTrackers = eventMappings[type];
    if (eventTrackers != null) {
        eventTrackers.map(f => f(state));
    }
}

function trackCompleteAction(state) {
    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_ACTION_COMPLETED, {
        ...state.widget,
        action: state.widget.activeAction,
        actionCompleteTime: state.electionReminder.actionCompletionTime
    });
}



// WEBPACK FOOTER //
// ./src/containers/Video/tracking.js